import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import {
  getUserPicture,
  getUserName,
  DEFAULT_AVATAR,
  getUserID
} from "src/auth/auth";
import { Avatar, Typography, Divider, Button, List } from "@material-ui/core";
import Lottie from "react-lottie";
import FileUpload from "src/components/fileUpload";
import { DubitoSvc } from "src/api";
import { openSnack } from "src/util/util";
import CalendarHeatmap from "react-calendar-heatmap";
import "react-calendar-heatmap/dist/styles.css";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import { RouteComponentProps } from "react-router";
import * as actions from "../../store/cases/actions";
import { User, Case, Category } from "src/api/classes";
import Loading from "../../components/loading";
import CaseListItem from "../cases/caseListItem";
import { Link } from "react-router-dom";

const animationData = require("../../assets/stone.json");

interface ProfileDetailParams {
  id: string;
}
interface Props extends RouteComponentProps<ProfileDetailParams> {
  users: User[];
  cases: Case[];
  categories: Category[];
  fetchUsers: () => void;
}
interface State {}
class Profile extends React.Component<Props, State> {
  state = {
    isStopped: false,
    isPaused: false,
    showUploadPP: false,
    activityValues: undefined,
    rawData: [],
    selectedDate: undefined,
    dayData: undefined
  };

  getTooltipDataAttrs = value => {
    // Temporary hack around null value.date issue
    //console.log(value);
    if (!value || !value.date) {
      return null;
    }

    // Configuration for react-tooltip
    return {
      "data-tip": ` ${value.count} activities + evidences <br/> ${moment(
        value.date
      ).format("dddd MMM DD, YYYY")}`
    };
  };

  handleClick = value => {
    if (!value || value === null) {
      this.setState({ dayData: undefined, selectedDate: undefined });
      return;
    }
    if (this.state.selectedDate !== value.date) {
      this.setState({ selectedDate: value.date, dayData: undefined });
      DubitoSvc.getActivityForDate(
        this.props.match.params.id,
        moment(value.date).format("YYYY-MM-DD")
      ).then(res => {
        this.setState({ dayData: (res as any).cases });
      });
    }
    /*  alert(
      `You clicked on ${value.date.toISOString().slice(0, 10)} with count: ${
        value.count
      }`
    ); */
  };
  componentDidMount() {
    this.loadData();
    if (!this.props.users || this.props.users.length === 0) {
      this.props.fetchUsers();
    }
  }
  loadData = () => {
    DubitoSvc.getActivityHeatmap(this.props.match.params.id).then(res => {
      const map = {};
      res.activities.map(a => {
        map[a.date] = { date: new Date(a.date), count: a.count };
      });
      res.evidences.map(e => {
        const old = map[e.date];
        if (!old) {
          map[e.date] = { date: new Date(e.date), count: e.count };
        } else {
          map[e.date] = {
            date: new Date(old.date),
            count: parseInt(old.count) + parseInt(e.count + "")
          };
        }
      });
      const values = Object.keys(map).map(key => map[key]);

      this.setState({ rawData: res, activityValues: values });
    });
  };
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    if (!this.props.users) {
      return <Loading />;
    }
    const user = this.props.users.find(
      u => u.id === parseInt(this.props.match.params.id)
    );
    if (!user) {
      return <div> User Not Found </div>;
    }
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 64
          }}
        >
          <Avatar
            style={{
              alignSelf: "center",
              width: 72,
              height: 72,
              marginBottom: 8
            }}
            src={user.account_picture || DEFAULT_AVATAR}
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_AVATAR;
            }}
          />
          <Typography variant="subheading">{user.name}</Typography>
          {this.props.match.params.id === getUserID() && (
            <Button
              onClick={() =>
                this.setState({ showUploadPP: !this.state.showUploadPP })
              }
              variant="outlined"
            >
              Change Profile Photo
            </Button>
          )}
          {/*  {this.state.showUploadPP && <FileUpload onUploaded={file => {}} />} */}
          {this.state.showUploadPP && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              {[0, 1, 2, 3, 4, 5, 6].map(i => {
                const url = `/assets/img/avatar${i !== 0 ? i : ""}.png`;
                return (
                  <div
                    onClick={() => {
                      this.changePP(url);
                    }}
                    style={{ margin: 4 }}
                  >
                    <img src={url} style={{ height: 72, width: 72 }} />
                  </div>
                );
              })}
            </div>
          )}
          <Divider style={{ width: "100%", marginTop: 24, marginBottom: 24 }} />
          {this.state.activityValues && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <div style={{ width: 900, alignSelf: "center" }}>
                <CalendarHeatmap
                  startDate={moment()
                    .subtract(1, "year")
                    .subtract(1, "day")}
                  endDate={moment()}
                  classForValue={value => {
                    if (!value) {
                      return "color-empty";
                    }
                    return `color-github-${Math.min(
                      parseInt(value.count / 5 + "") + 1,
                      4
                    )}`;
                  }}
                  values={this.state.activityValues}
                  tooltipDataAttrs={this.getTooltipDataAttrs}
                  onClick={this.handleClick}
                />
              </div>
              <ReactTooltip multiline />
            </div>
          )}
          {this.state.selectedDate && !this.state.dayData && <Loading />}
          {this.state.dayData && (
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                alignSelf: "center",
                width: "90%",
                maxWidth: 900,
                marginLeft: 28,
                marginRight: 28
              }}
            >
              <Typography variant="title" style={{ color: "gray" }}>
                Cases Worked on{" "}
                <i style={{ color: "black" }}>
                  {moment(this.state.selectedDate).format("dddd MMMM DD, YYYY")}
                </i>
              </Typography>
              <List style={{ flex: 1 }}>
                {this.state.dayData.map(d => {
                  const c = this.props.cases.find(i => i.id === d);
                  if (c) {
                    return (
                      <Link
                        key={c.id}
                        to={"/case/" + c.id}
                        style={{ flex: 1, textDecoration: "none" }}
                      >
                        <CaseListItem
                          key={c.id}
                          case={c}
                          users={this.props.users}
                          categories={this.props.categories}
                        />
                      </Link>
                    );
                  }
                })}
              </List>
            </div>
          )}
          {/*  <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1
            }}
          >
            <Lottie
              options={defaultOptions}
              height={250}
              width={300}
              isStopped={this.state.isStopped}
              isPaused={this.state.isPaused}
            />
            <div style={{ textAlign: "center" }}>{"Coming soon"}</div>
          </div> */}
        </div>
      </div>
    );
  }
  changePP = (url: string) => {
    DubitoSvc.updateProfile({ account_picture: url })
      .then(() => {
        openSnack("Profile updated succesfully!", "success");
        localStorage.setItem("dubito/accountPicture", url);
        window.location.reload();
      })
      .catch(() => {
        openSnack("Profile update failed!", "error");
      });
  };
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    users: state.cases.users,
    cases: state.cases.list,
    categories: state.cases.categories
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchUsers: () => dispatch(actions.fetchUsers())
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/pages/profile/index.tsx